module.exports = __webpack_public_path__ + "img/skitime1.352fc5ba.jpg";